import { getToken } from '../_helpers/commonFunctions';
import call from './apiRequest';
import apiEndpoints from './apiEndpoints';

/**
 * Api call to download completed reports pdf
 * @param {object} payload
 */
const downloadReportPdf = (payload) =>
  call({
    method: 'get',
    endpoint: `${apiEndpoints.downloadReportPdf}/${payload.projectName}`,
    authKey: getToken(),
    timeout: 15000,
  });

/**
 * Api call to delete reports pdf
 * @param {object} payload
 */
export const deleteReportPdf = (reportId) =>
  call({
    method: 'get',
    endpoint: `${apiEndpoints.deleteReportPdf}/${reportId}`,
    authKey: getToken(),
  });

/**
 * Api call to email reports pdf
 * @param {object} payload
 */
export const emailReportPdf = (reportId, recipients) =>
  call({
    method: 'post',
    endpoint: `${apiEndpoints.emailReportPdf}/${reportId}`,
    payload: {
      recipients,
    },
    authKey: getToken(),
  });

export default downloadReportPdf;
